import {FormControl, FormGroupDirective, NgForm, ValidationErrors} from '@angular/forms';
import {Injectable} from '@angular/core';
import {ErrorStateMatcher} from '@angular/material/core';

@Injectable({providedIn: 'root'})
export class ShowAlwaysErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, _form: FormGroupDirective | NgForm | null): boolean {
    if (control?.touched) {
      if (control.invalid) {
        return true;
      }
      const formGroup = control.parent;
      if (formGroup) {
        if (formGroup.status === 'INVALID') {
          if (formGroup.errors) {
            let controlKey: string | null = null;
            for (const key in formGroup.errors) {
              if (formGroup.errors.hasOwnProperty(key)) {
                const myControl = formGroup.get(key);
                if (myControl === control) {
                  controlKey = key;
                  break;
                }
              }
            }
            if (controlKey) {
              if (control.status !== 'INVALID') {
                const errors: ValidationErrors = {};
                errors[controlKey] = formGroup.errors[controlKey];
                control.setErrors(errors);
                return true;
              }
            }
          }
        }
      }
    }
    return false;
  }
}
